
import React from "react";
import { Button } from "@/components/ui/button";
import { WaitlistWidget } from "@/components/WaitlistWidget";

type HeroCTAProps = {
  onOpenWaitlist: () => void;
};

export const HeroCTA = ({ onOpenWaitlist }: HeroCTAProps) => {
  const scrollToHowItWorks = () => {
    const howItWorksSection = document.getElementById('how-it-works');
    if (howItWorksSection) {
      howItWorksSection.scrollIntoView({ behavior: 'smooth' });
      
      // Set focus to the section for accessibility
      howItWorksSection.tabIndex = -1;
      howItWorksSection.focus({ preventScroll: true });
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      scrollToHowItWorks();
      e.preventDefault();
    }
  };

  return (
    <div className="flex flex-col sm:flex-row gap-4 pt-2">
      <WaitlistWidget variant="hero" />
      <Button 
        size="lg" 
        variant="outline" 
        className="rounded-full border border-[#2432ff]/20 hover:border-[#2432ff]/40 hover:bg-[#2432ff]/5 text-[#2432ff] px-6 py-3 h-auto focus:ring-2 focus:ring-[#2432ff]/40 focus:outline-none"
        onClick={scrollToHowItWorks}
        onKeyDown={handleKeyDown}
        aria-label="See how it works"
      >
        See How It Works
      </Button>
    </div>
  );
};
